import React from "react";
import classNames from "classnames";

import { useModal } from "@root/client/modal";
import { VisibilitySwitch } from "@common/visibilitySwitch";
import { Props } from "./types";
import styles from "./styles.scss";

function NameEditionForm({ event, hovered }: Props) {
  const [name, setName] = React.useState(event.name);
  const { pushView } = useModal();
  const inputRef = React.useRef<HTMLInputElement>(null);
  const nameRef = React.useRef<HTMLHeadingElement>(null);
  const [isHovered, setIsHovered] = React.useState(false);

  React.useEffect(() => {
    setName(event.name);
  }, [event.name]);

  // useMessage(
  //   (message) =>
  //     message.type === events.editEventFailed &&
  //     event.uuid === message.data.event.uuid &&
  //     setName(event.name)
  // );
  const isTextTruncated = () => {
    if (nameRef.current) {
      return nameRef.current.offsetWidth < nameRef.current.scrollWidth;
    }
    return false;
  };

  return (
    <VisibilitySwitch
      renderChildren={(isVisible, show, hide) => (
        <div
          className={classNames(styles.nameEditionForm, {
            [styles.edition]: isVisible,
            [styles.hovered]: hovered,
          })}
        >
          <form
            className={styles.form}
            onSubmit={(e) => {
              e.preventDefault();
              hide();
            }}
          >
            <input
              ref={inputRef}
              className={styles.input}
              value={name}
              onBlur={() => {
                hide();
                setName(event.name);
              }}
              onChange={({ target }) => setName(target.value)}
            />
          </form>
          <div className={styles.name}>
            <h3
              ref={nameRef}
              onMouseEnter={() => setIsHovered(true)}
              onMouseLeave={() => setIsHovered(false)}
            >
              {event.name}
            </h3>
            {isTextTruncated() && isHovered && (
              <div className={styles.tooltip}>{event.name}</div>
            )}
            {/*<div*/}
            {/*  onClick={(e) => {*/}
            {/*    e.stopPropagation();*/}
            {/*    show();*/}
            {/*    setTimeout(() => {*/}
            {/*      inputRef.current && inputRef.current.focus();*/}
            {/*    });*/}
            {/*  }}*/}
            {/*>*/}
            {/*  <EditIcon*/}
            {/*    className={styles.icon}*/}
            {/*    style={{ color: event.status.color }}*/}
            {/*  />*/}
            {/*</div>*/}
          </div>
        </div>
      )}
    />
  );
}

export { NameEditionForm };
